import { render, staticRenderFns } from "./CourseTitle.vue?vue&type=template&id=3b0198ff&"
import script from "./CourseTitle.vue?vue&type=script&lang=ts&"
export * from "./CourseTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports